import { css } from '@emotion/react';
import * as React from 'react';

import { DeliveryTime } from 'api/api';

import { getDeliveryWeeks } from '~src/commons/utils/delivery-time/delivery-time';
import { formatWeekNumbers } from '~src/commons/utils/delivery-time/delivery-time-max-formatters';
import { useTranslations } from '~src/commons/utils/translations/translate';
import { commonStyles } from '~src/theme/common-styles';
import { fontStyles } from '~src/theme/fontStyles';

import { Text } from '../commons/components';

type Props = {
  deliveryTime: DeliveryTime;
  locale: string;
  asShippingWeek: boolean;
  ellipsisOn: boolean;
};

export const DeliveryDate: React.FC<Props> = ({ locale, ellipsisOn, deliveryTime }) => {
  const { tICU } = useTranslations();

  const { deliveryWeekMin, deliveryWeekMax } = getDeliveryWeeks(deliveryTime, locale);

  const deliveryWeeksAreTheSame = deliveryWeekMin === deliveryWeekMax;

  const weekOfYear = formatWeekNumbers({
    deliveryTime,
    translate: tICU,
    locale,
    deliveryWeeksAreTheSame,
    addTranslations: false,
  });

  return (
    <div css={styles.titleContent(ellipsisOn)}>
      <Text css={styles.title} textStyle={styles.titleText} color="neutral35">
        {tICU('widget.PREORDER_DELIVERY_WEEK', { week: weekOfYear })}
      </Text>
    </div>
  );
};

const styles = {
  titleContent: (ellipsisOn?: boolean) =>
    css({
      ...(ellipsisOn ? commonStyles.ellipsis : {}),
    }),
  title: css({
    display: 'inline',
    width: '100%',
  }),
  titleText: css({
    fontStyle: 'normal',
    ...fontStyles.px14_20,
    fontVariationSettings: "'wght' 400",
    textTransform: 'none',
    letterSpacing: 0,
  }),
};
